import React from "react";
import PlusButton from "../buttons/PlusButton";
import WatchButton from "../buttons/WatchButton";
import "./MoviesDesc.scss";
const MoviesDesc = ({ title }) => {
  return (
    <div className="movie-desc">
      <div className="movie-desc__name">{title}</div>
      <div className="movie-desc__user">
        <div className="movie-desc__gener">Drama, Action, Thriller</div>
        <div className="movie-desc__match">94% Match</div>
      </div>
      <div className="movie-desc__buttons">
        <WatchButton />
        <PlusButton />
      </div>
    </div>
  );
};
export default MoviesDesc;
